function r(t, i) {
  if (t == null)
    return {};
  var o = {};
  for (var e in t)
    if ({}.hasOwnProperty.call(t, e)) {
      if (i.includes(e))
        continue;
      o[e] = t[e];
    }
  return o;
}
export {
  r as default
};
//# sourceMappingURL=objectWithoutPropertiesLoose2.mjs.map
